import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BannersModule } from './banners/banners.module';
import { ButtonsModule } from './buttons/buttons.module';
import { CardsModule } from './cards/cards.module';
import { AWFormsModule } from './forms/forms.module';
import { ImagesModule } from './images/images.module';
import { ListsModule } from './lists/lists.module';
import { SlidersModule } from './sliders/sliders.module';
import { TemplatesModule } from './template/template.module';
import { TextsModule } from './texts/texts.module';
import { VedioDisplayModule } from './video_display/video_display.module';
import { WeatherIconModule } from './weather-icon/weather-icon.module';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    TextsModule,
    CardsModule,
    TemplatesModule,
    ListsModule,
    ImagesModule,
    SlidersModule,
    ButtonsModule,
    AWFormsModule,
    BannersModule,
    VedioDisplayModule,
    WeatherIconModule
],
  exports: [
    TextsModule,
    CardsModule,
    TemplatesModule,
    ListsModule,
    ImagesModule,
    SlidersModule,
    ButtonsModule,
    AWFormsModule,
    BannersModule,
    VedioDisplayModule,
    WeatherIconModule
  ]
})
export class UiComponentsModule { }
